export default {
  All: 'all',
  SystemDefined: 'systemDefined',
  UserDefined: 'userDefined',
}
